import { types } from 'mobx-state-tree'

export const QuestionType = types.union(
  types.literal('single_choice'),
  types.literal('multiple_choice'),
  types.literal('open_text'),
  types.literal('range_response'),
  types.literal('true_false'),
)
